//export const SERVICE_URL   = "http://192.168.0.192:6666/bilapp/Service/";

//export const SERVICE_URL   = "http://192.168.0.143:58838/";

//export const SERVICE_URL   = "http://localhost:58838/";

export const SERVICE_URL     = "http://www.bilapp.it/Service/";

export const SERVICE_URL_API = SERVICE_URL+ "api/";
export const URL_LOGIN       = SERVICE_URL + "Token";
export const URL_LOGOUT      = SERVICE_URL_API + "Account/Logout";

//CONFIRM EMAIL
export const URL_EMAIL_CONFIRM             = SERVICE_URL + "api/Account/ConfirmEmail"
export const URL_RECOVER_CONVALIDATE_TOKEN = SERVICE_URL + "api/Account/ConvalidateRecoverToken";
export const URL_RECOVER_SET_PASSWORD      = SERVICE_URL + "api/Account/RecoverSetPassword";
//REPORT
export const URL_REPORT                    = SERVICE_URL_API + "Export/Pesate";
//CHECKUSERNAME
export const URL_checkUsername            = SERVICE_URL_API + "Account/checkUsername";
export const URL_checkEmail               = SERVICE_URL_API + "Account/checkEmail";
export const URL_PAYMENT_CONFIG           = SERVICE_URL_API + "Payment/PaypalConfig";
export const URL_PAYMENT_PRICES           = SERVICE_URL_API + "Payment/PaypalPrices";
export const URL_SIGNIN_CLOUD             = SERVICE_URL_API + "Account/RegisterCloudApp";
export const URL_SIGNIN_ASSOCIATE_CLOUD   = SERVICE_URL_API + "Account/AssociateUser";
export const URL_SIGNIN_PRO               = SERVICE_URL_API + "Account/RegisterProApp";
export const LINK_PLAY_STORE              = "https://play.google.com/store/apps/details?id=com.industrialsoftware.bilapp1";
export const LINK_INDUSTRIAL_SOFTWARE     = "http://www.industrialsoftware.it/";
export const LINK_BILANCIAI               = "http://www.coopbilanciai.it/it/home";
export const LINK_VIDEO_BILAPP            = "http://bilapp.industrialsoftware.biz/Content/Video/bilapp.mp4"


// WEBPACK FOOTER //
// ./src/Utils/Strings/URL.js